export function calculateCompletionStatus( courseStatus ){

    if( courseStatus.completed >= courseStatus.scoAmount ) {
        return "completed";
    }

    if ( courseStatus.completed > 0 || courseStatus.incomplete > 0 || courseStatus.scoAmount > 0 ) {
        return "incomplete";
    }

    return "not attempted";
}
